import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Search {
  constructor() {
    _defineProperty(this, "gambits", {});
  }
  gambit(modelType, gambit) {
    var _this$gambits;
    (_this$gambits = this.gambits)[modelType] || (_this$gambits[modelType] = []);
    this.gambits[modelType].push(gambit);
    return this;
  }
  extend(app, extension) {
    for (const [modelType, gambits] of Object.entries(this.gambits)) {
      for (const gambit of gambits) {
        var _app$search$gambits$g;
        (_app$search$gambits$g = app.search.gambits.gambits)[modelType] || (_app$search$gambits$g[modelType] = []);
        app.search.gambits.gambits[modelType].push(gambit);
      }
    }
  }
}
flarum.reg.add('core', 'common/extenders/Search', Search);